<template>
  <div class="container-history">
    <div v-for="(request, index) in requests" :key="index" class="contianer-gral">
      <div class="container-info">
        <p class="request-title">{{ request.billing_Name }}</p>
        <p class="request-subtitle">Solicitado: {{ formatFecha(request.request_Date) }}</p>
      </div>
      <div class="btn">
        <v-btn style="border-radius: 30px;" @click="viewRequest(request)">Ver</v-btn>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    requests: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    formatFecha(fecha) {
      return new Date(fecha).toLocaleDateString();
    },
    viewRequest(selectedRequest) {
      this.$emit('viewRequest', selectedRequest);
    }
  }
}
</script>

<style scoped>
.container-history {
  width: 100%;
  height: 100% !important;
  background-color: #eaeaea;
  border-radius: 10px;
  padding: 10px;
}
.contianer-gral {
  padding: inherit;
  display: flex;
  flex-direction: column;
  transition: background-color 0.5s;
  border-radius: 10px !important;
  margin-bottom: 5px;
}
.contianer-gral:hover {
  background-color: white;
}
.request-title {
  font-size: 14px !important;
  margin-bottom: 5px !important;
  font-family: Roboto !important;
  font-weight: bold !important;
  font-style: normal;
  text-align: left;
  color: #274280;
}

.request-subtitle {
  font-size: 13px !important;
  font-family: Roboto !important;
  color: rgba(0, 0, 0, 0.6);
}
.btn {
  display: flex;
  justify-content: flex-end;
}
</style>
